/**
 * css変数を設定
 */
export function setCssVar(): void {
  const root = document.documentElement;
  const unit = 'px';

  $(window).on('load scroll resize', (e) => {
    const iw = window.innerWidth ?? 1;
    const ih = window.innerHeight ?? 1;
    const cw = root.clientWidth ?? 1;
    const ch = root.clientHeight ?? 1;
    const vw = cw / 100;
    const scrollbar = iw - cw + (iw > 1920 ? 1 : 0);
    root.style.setProperty('--scrollbar', `${scrollbar}${unit}`);
    root.style.setProperty('--vw', `${vw}${unit}`);
    root.style.setProperty('--inner_width', `${iw}${unit}`);
    root.style.setProperty('--inner_height', `${ih}${unit}`);
    root.style.setProperty('--client_width', `${cw}${unit}`);
    root.style.setProperty('--client_height', `${ch}${unit}`);
    const scale_landscape = (ih / iw) * (16 / 9);
    const scale_sumaho = (ih / iw) * (9 / 16);
    root.style.setProperty('--scale_landscape', scale_landscape > 1 ? '1' : scale_landscape.toString());
    root.style.setProperty('--scale_sumaho', scale_sumaho > 1 ? '1' : scale_sumaho.toString());
  });
}
